var _desc, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSortIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "19px",
    height: "25px",
    viewBox: "0 0 19 25",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Group") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(1.427710, 0.958515)",
    stroke: "#222A73",
    strokeWidth: 1.5
  }, /*#__PURE__*/React.createElement("g", {
    id: "arrow-down",
    transform: "translate(0.000000, 9.000000)"
  }, /*#__PURE__*/React.createElement("polyline", {
    id: "Path-6",
    points: "8.8817842e-16 8.12859517 5.2404385 13.6571232 10.4516814 8.12859517"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 5.2258407,
    y1: 0,
    x2: 5.2258407,
    y2: 13.2003103,
    id: "Path-7"
  })), /*#__PURE__*/React.createElement("g", {
    id: "arrow-up",
    transform: "translate(11.500000, 7.000000) scale(1, -1) translate(-11.500000, -7.000000) translate(6.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("polyline", {
    id: "Path-6",
    points: "8.8817842e-16 8.12859517 5.2404385 13.6571232 10.4516814 8.12859517"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 5.2258407,
    y1: 0,
    x2: 5.2258407,
    y2: 13.2003103,
    id: "Path-7"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSortIcon);
export default __webpack_public_path__ + "static/media/sort-icon.e6222f30cc2e9b28de9b9fac188addeb.svg";
export { ForwardRef as ReactComponent };